import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { TypeUtils } from '../../../framework/utils/UtilityTypes';
import { IdParam } from '../../models/gen/idParam';
import { NoticeGetResult } from '../../models/gen/noticeGetResult';
import { NoticeSearchParam } from '../../models/gen/noticeSearchParam';
import { NoticeSearchResult } from '../../models/gen/noticeSearchResult';
import {
  useGenericMutation,
  useGenericQuery,
} from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const NOTICE_CONTEXT_NAMES = {
  GET_NOTICE: 'getNotice',
  POST_NOTICE_SEARCH: 'searchNotice',
} as const;

const apis = apiGenerator();

/**
 * GET `/notice/{id}`
 *
 * @param param -
 * @returns
 */
export const useGetNotice = (param: IdParam) =>
  useGenericQuery(
    [NOTICE_CONTEXT_NAMES.GET_NOTICE, param as Record<string, unknown>],
    async (_param) =>
      apis.get<void, NoticeGetResult>(
        `${env.BASE_API_ENDPOINT}/notice/${param.id}`,
        { ...queryOptions }
      ),
    { enabled: !!param.id }
  );

/**
 * POST `/notice/search`
 *
 * @param param -
 * @returns
 */
export const usePostNoticeSearch = () =>
  useGenericMutation(async (param: NoticeSearchParam) =>
    apis.post<NoticeSearchParam, NoticeSearchResult>(
      `${env.BASE_API_ENDPOINT}/notice/search`,
      { ...queryOptions, data: param }
    )
  );

export const usePostNoticeSearchPolling = (
  param: NoticeSearchParam,
  pollingInterval?: number
) =>
  useGenericQuery(
    [NOTICE_CONTEXT_NAMES.POST_NOTICE_SEARCH, param as Record<string, unknown>],
    async () =>
      apis.post<NoticeSearchParam, NoticeSearchResult>(
        `${env.BASE_API_ENDPOINT}/notice/search`,
        { ...queryOptions, data: param }
      ),
    {
      enabled: false,
      refetchInterval: TypeUtils.isNonNilNumber(pollingInterval)
        ? pollingInterval
        : false,
      refetchIntervalInBackground: true,
      staleTime: 0,
    }
  );
